(function () {
  // Reset stuck cart.attributes.collection_grid_view so theme uses default grid
  if (document.querySelector('#collection.l4cl')) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { collection_grid_view: '' } })
    });
  }

  // ── Sort inline dropdown ──────────────────────────────────────────────────
  var sortRoot   = document.querySelector('[data-sort]');
  if (sortRoot) {
    var sortToggle = sortRoot.querySelector('[data-sort-toggle]');
    var sortList   = sortRoot.querySelector('[data-sort-list]');
    var sortLabel  = sortRoot.querySelector('[data-sort-label]');

    function openSort() {
      sortList.hidden = false;
      sortRoot.dataset.open = '';
      sortToggle.setAttribute('aria-expanded', 'true');
    }

    function closeSort() {
      sortList.hidden = true;
      delete sortRoot.dataset.open;
      sortToggle.setAttribute('aria-expanded', 'false');
    }

    sortToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      sortList.hidden ? openSort() : closeSort();
    });

    document.addEventListener('click', function (e) {
      if (!sortRoot.contains(e.target)) closeSort();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSort();
    });

    sortList.querySelectorAll('[data-sort-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.dataset.sortValue;

        // Immediate visual feedback
        sortList.querySelectorAll('[data-sort-value]').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        if (sortLabel) sortLabel.textContent = btn.querySelector('span').textContent.trim().toUpperCase();

        setTimeout(function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', value);
          window.location.href = url.toString();
        }, 160);
      });
    });
  }

  // Swatch click → swap product card image
  document.addEventListener('click', function (e) {
    var li = e.target.closest('#collection .check.color li[data-img]');
    if (!li) return;

    var card = li.closest('.product-card');
    if (!card) return;

    var newSrc = li.dataset.img;
    var img = card.querySelector('figure img');
    if (!newSrc || !img) return;

    e.preventDefault();

    // Fade swap
    img.style.opacity = '0';
    setTimeout(function () {
      img.src = newSrc;
      img.style.opacity = '1';
    }, 140);

    // Active dot
    var swatches = card.querySelectorAll('#collection .check.color li');
    swatches.forEach(function (s) { s.classList.remove('vz-active'); });
    li.classList.add('vz-active');
  });
})();
